module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/2@2x_dcaf886e2f63c55052f273a1586d180e.png";